import { userGridItemFrag, userWorkplaceFrag } from '../../../../../../services/types/user.types';

export const personContactFrag = `
    id
    personId
    active
    type
    subType
    validFrom
    validTo
    note
    created
    order
    primary
    relation
    doctorSpecialization
    data {
        circumstance
        info
        purposeOfAuthorization
        scopeOfAuthorization
        dateOfAuthorization
        authorizationFrom
        authorizationTo
        doctorSpecializationCode
        doctorWorkplaceId
        basis
        referenceNumber
        isRelative
        municipality
    }
    doctorWorkplace {
        ${userWorkplaceFrag}
    }
    user {
        ${userGridItemFrag}
    }
`;
